import Vue from "vue";
import Router from "vue-router";

import SubmitRequest from "../request/SubmitRequest.vue";
import PrintRequest from "../request/PrintRequest.vue";
import Error from "../Error.vue";

import store from "../store";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      redirect: "/submitRequest",
    },
    {
      path: "/submitrequest",
      name: "SubmitRequest",
      component: SubmitRequest,
      beforeEnter(to, from, next) {
        if (store.state.requestStatus === "request") {
          window.scrollTo(0, 0);
          next();
          return;
        }

        next(false);
        return;
      },
    },
    {
      path: "/printRequest",
      name: "PrintRequest",
      component: PrintRequest,
      beforeEnter(to, from, next) {
        if (store.state.requestStatus === "print") {
          window.scrollTo(0, 0);
          next();
          return;
        }

        next(false);
        return;
      },
    },
    {
      path: "/error",
      name: "Error",
      component: Error,
      beforeEnter(to, from, next) {
        if (store.state.requestStatus === "error") {
          window.scrollTo(0, 0);
          next();
          return;
        }

        next(false);
        return;
      },
    },
  ],
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    // eslint-disable-next-line no-undef
    NProgress.start();
  }
  next();
});
// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  if (to.name) {
    // eslint-disable-next-line no-undef
    NProgress.done();
  }
});

export default router;
